import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="font-heading text-8xl font-extrabold text-primary-200 md:text-[10rem]">
        404
      </span>
      <h1 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        这个页面走丢啦
      </h1>
      <p className="mt-2 font-mono text-sm text-foreground-400">{location.pathname}</p>
      <p className="mt-3 max-w-md text-sm text-foreground-500">
        你要找的页面可能已被移除或链接有误，不如回到首页继续追番吧。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-200 bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
        >
          <i className="ri-layout-grid-line" />
          浏览分类
        </Link>
      </div>
    </div>
  );
}